<template>
  <div>
    <a-card bordered>
      <span slot="title">
        <a-tag color="green">{{ mode == "Create" ? "Create" : "Edit" }}</a-tag>
        Account Receivables Employee
      </span>

      <a-form-model ref="form" :model="form" :rules="rules">
        <a-row :gutter="12">
          <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
            <a-card bordered>
              <a-form-model-item label="Period" prop="periode">
                  <a-select
                    showSearch
                    v-model="form.periode"
                    :disabled="disabledForm || mode=='Edit'"
                  >
                    <a-select-option v-for="item in option.periode" :key="item.value">
                      {{ item.label }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>

              <a-form-model-item label="Description" prop="description">
                <a-input v-model="form.description" :disabled="disabledForm || mode=='Edit'"/>
              </a-form-model-item>
              
              <a-form-model-item label="Note" prop="note">
                <a-textarea v-model="form.note" :rows="5" :disabled="disabledForm || mode=='Edit'"></a-textarea>
              </a-form-model-item>
              <a-form-model-item ref="file" prop="file" label="File Attachment">
                <a-upload
                  v-model="form.file"
                  :showUploadList="true"
                  :fileList="push"
                  :beforeUpload="beforeUpload"
                  :remove="handleRemoveList"
                  :disabled="disabledForm || mode=='Edit'"
                >
                  <a-button
                    ref="btndocument"
                    icon="upload"
                    :disabled="disabledForm || mode=='Edit'"
                    >Select File
                  </a-button>
                </a-upload>
              </a-form-model-item>
              <div class="action">
                <a-button :loading="loading.generate" type="primary" :disabled="mode=='Edit'" @click="handleGen()">
                  {{ disabledForm ? "Reset" : "Generate" }}
                </a-button>
              </div>
            </a-card>
          </a-col>
        
          <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
            <a-collapse :class="getScreen ? 'margin-top' : ''"
                  activeKey="1"
                >
                  <a-collapse-panel key="1" style="min-height: 423px;!important">
                    <div slot="header" class="m-display-flex space-between align-middle">
                      <h4  class="margin-remove">Detail Account Receivables Employee</h4>
                      <a-button v-if="mode=='Edit'" size="small" type="primary" class="margin-right" icon="plus" @click="handleAddDetail">Add</a-button>
                    </div>
                    <a-config-provider :locale="getLocalConfigProvider()">
                      <a-table
                        rowKey="piutang_karyawan_id"
                        id="piutang_karyawan"
                        :columns="columns"
                        :dataSource="detail"
                        :pagination="pagination"
                        size="small"
                        bordered
                        :scroll="{ x: 600 }"
                      >
                        <div slot="no" slot-scope="text, record, index">
                          {{index+1}}
                        </div>
                        <div slot="nama" slot-scope="text, record, index">
                          <span>{{record.end_user}}</span><br/>
                          <span>{{record.piutang_karyawan_no}}</span>
                        </div>
                        <div slot="val_i" slot-scope="text, record, index">
                          <span>{{formatCurrency('IDR',record.value_installment)}}</span>
                        </div>
                        <div slot="balance" slot-scope="text, record, index">
                          <span>{{formatCurrency('IDR',record.remaining_balance)}}</span>
                         
                        </div>
                        <template slot="act" slot-scope="text, data">
                          <a-button-group>
                              <a-button
                                type="primary"
                                @click="edit(data)"
                                icon="edit"
                              >
                              </a-button>
                              <a-button
                                type="danger"
                                @click="delet(data)"
                                icon="close"
                              >
                              </a-button>
                          </a-button-group>
                        </template>
                        <div slot="footer" class="m-display-flex space-between align-middle">
                          <h3>GRAND TOTAL</h3>
                          <h3>
                            {{
                              formatCurrency(
                                "IDR",
                                grandtotal
                              )
                            }}
                          </h3>
                        </div>
                      </a-table>
                    </a-config-provider>
                  </a-collapse-panel>
            </a-collapse>
          </a-col>
        </a-row>
      </a-form-model>
      <div class="action">
        <a-button :loading="loading.submit" type="primary" @click="handleSave()">Save</a-button>
      </div>
    </a-card>

    <a-modal
        v-if="modalEdit"
        v-model="modalEdit"
        title="Edit Form"
        :width="500"
        centered
        :maskClosable="false"
        okText="Submit"
        cancelText="Cancel"
        @ok="handleOk"
        @cancel="handleClose"
      >
      <a-form :form="formedit">
        <a-form-item
        label="ID"
        hidden="true"
        >
          <a-input v-decorator="['id', {rules: [{required: true, message:'Id can\'t be empty!'}]}]"/>
        </a-form-item>
        <a-form-item
        label="Value"
        >
          <a-input-number
            :min="0"
            class="m-width-full m-text-align right"
            @keydown="onlyNumber"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-decorator="['val', {rules: [{required: true, message:'value can\'t be empty!'}]}]"
          ></a-input-number>
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      v-if="modalAddTlc"
      v-model="modalAddTlc"
      title="Add TLC Employee"
      centered
      :maskClosable="false"
      okText="Submit"
      cancelText="Cancel"
      @ok="handleOKAddDetail"
      @cancel="handleCloseAddDetail"
      :confirmLoading="loadConfirmAddDetail"
    >
      <a-config-provider :locale="getLocalConfigProvider()">
        <a-select
          mode="multiple"
          placeholder="Please select"
          v-model="tlcAddDetail"
          class="m-width-full"
        >
          <a-select-option
            showSearch
            v-for="tlc in tlcAdditional"
            :key="tlc"
            >{{ tlc }}</a-select-option
          >
        </a-select>
      </a-config-provider>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  name: "pembayaranPiutang-create",
  props: ["id"],
  mixins: [GlobalMethod,CurrencyFormat],
  data() {
    let doc_validation = (rule, value, callback) => {
      if (this.push == null || this.push.length==0) {
        callback(new Error("Please input File Attachment"));
      } else {
        callback();
      }
    };

    const columns = [
      {
        title: "#",
        align: "right",
        width: 50,
        scopedSlots: { customRender: "no" },
      },
      {
        title: "Name",
        width: 200,
        scopedSlots: { customRender: "nama" },
      },
      {
        title: "Installment to",
        width: 100,
        align: 'center',
        dataIndex: "installment_to",
      },
      {
        title: "Value installment",
        width: 150,
        align: 'center',
        scopedSlots: { customRender: "val_i" },
      },
       {
        title: "Remaining Balance",
        width: 150,
        align: 'center',
         scopedSlots: { customRender: "balance" },
      },
      {
        title: "Action",
        width: 100,
        align: 'center',
        scopedSlots: { customRender: "act" },
      },
    ];

    return {
      mode: "Create",
      loading: {
        submit: false,
        generate: false,
      },
       form: {
       
        periode: null,
        description: null,
        note: null,
        file: null,
       
      },
      dataedit: {},
      rules: {
        periode: {
          required: true,
          message: "Please input Period",
          trigger: "blur",
        },
        description: {
          required: true,
          message: "Please input Description",
          trigger: "blur",
        },
        
        file: {
          required: true,
          validator: doc_validation, 
          trigger: "change",
        },
       
        note: {
          required: true,
          message: "Please input Note",
          trigger: "blur",
        },
      },
      
      push:[],
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      detail: [],
      columns,
      modalEdit: false,
      disabledForm: false,
      modalAddTlc: false,
      tlcAdditional: [],
      tlcAddDetail: [],
      loadConfirmAddDetail: false,
      option: {
        periode : []
      },
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat", "getStandartFormatDate",
    "getListPembayaranPiutang","getScreen"]),
    grandtotal(){
      return _.sumBy(this.detail, function (val) {
        return Number(val.value_installment);
        });
    },
  },
  watch: {
    dataedit() {
      this.initialData();
    },
  },
  mounted() {
    this.generateOption()
    this.fetch();
    this.initialData();

    Event.$on("confirmMessageReturn", this.handleSaveProcess);
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.handleSaveProcess);
  },
  created(){
    this.formedit = this.$form.createForm(this);
  },  
  methods: {
    moment,
    initialData() {
      this.form = {
        description: this.mode == "Edit" ? this.dataedit.description : null,
        file: this.mode == "Edit" ? parseInt(this.dataedit.file) : 0,
        note: this.mode == "Edit" ? this.dataedit.note : null,
      };
    },
    fetch() {
    if (this.id) {
        this.$store
          .dispatch("getRevisipembayaranPiutang", { auth: this.getAuth, id_manifest: this.id })
          .then((res) => {
            this.dataedit = res.hdr[0];
            this.detail = res.dtl;
            this.tlcAdditional = res.tlc;
            this.mode = "Edit";
         
          let typefile = this.dataedit.file_url.substr(this.dataedit.file_url.lastIndexOf("."));
            
            if (typefile == ".xls"){
              typefile = "data:application/vnd.ms-excel;base64,";
            } else if(typefile == ".xlsx"){
              typefile = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
            } else if(typefile == ".doc"){
              typefile = "data:application/msword;base64,";
            } else if(typefile == ".docx"){
              typefile = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
            } else if(typefile == ".pdf"){
              typefile = "data:application/pdf;base64,";
            } else if(typefile == ".jpeg" || typefile == ".jpg"){
              typefile = "data:image/jpeg;base64,";
            } else if(typefile == ".png"){
              typefile = "data:image/png;base64,";
            }

            var file = this.dataURLtoFile(
              typefile + this.dataedit.files,
              this.dataedit.file_nm
            );
            file.uid = "vc-upload-1-1";
            file.status = "done";
            file.exist = true;
            file.url = this.$serviceUrl + this.dataedit.file_attachment;
            this.push.push(file);
            this.spining = false;
          });
    
        }
      
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    
    handleSave() {
      if (this.mode === "Edit") {
        this.confirmMessage("confirm-edit");
      } else if (this.mode === "Create") {
        this.confirmMessage("confirm-save");
      }
    },
    handleSaveProcess() {
      this.$refs.form.validate((valid) => {
          if (!valid) {
            this.displayMessage("form-warning");
            return;
          }

        this.loading.submit = true;

        let totals = 0;
        let data = new FormData();
        data.append("tlc",this.getAuth.username);
        data.append("periode", this.form.periode);
        data.append("description",this.form.description);
        data.append("note",this.form.note);
        data.append("upload_file",this.push[0]);

        this.detail.forEach((item, index) => {
          data.append("dtl["+index+"][piutang_karyawan_id]", item.piutang_karyawan_id);
          data.append("dtl["+index+"][piutang_karyawan_no]", item.piutang_karyawan_no);
          data.append("dtl["+index+"][end_user]", item.end_user);
          data.append("dtl["+index+"][installment_to]", item.installment_to);
          data.append("dtl["+index+"][value_installment]", item.value_installment);
          data.append("dtl["+index+"][remaining_balance]", item.remaining_balance);
          
          totals += Number(item.value_installment);
        });

        data.append("total", totals);

        if(this.mode=="Create"){
          this.$store
            .dispatch("submitpembayaranPiutang", { auth: this.getAuth, payload: data })
            .then((res) => {
              this.displayMessage("success");
              this.loading.submit = false;
              this.$router.go(-1);
            })
            .catch((err) => {
              this.displayMessageValue("basic-error", err.response.data.message);
              this.loading.submit = false;
            });
        }else{
            data.append("piutang_karyawan_byr_id", this.id);

            this.$store
            .dispatch("submitRevisipembayaranPiutang", { auth: this.getAuth, payload: data })
            .then((res) => {
              this.displayMessage("success");
              this.loading.submit = false;
              this.$router.go(-1);
            })
            .catch((err) => {
              this.displayMessageValue("basic-error", err.response.data.message);
              this.loading.submit = false;
            });
        }
      });
    },
    handleRemoveList() {
      if (this.disabledForm){
        this.displayMessageValue("basic-error", "can't be delete cause form is disabled!");
      }else{
        this.form.file = undefined;
        this.push = [];
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.push= [file];
        return false;
      }
    },
    enabledForm(){
      this.$refs['form'].resetFields();
      this.push = [];
      this.disabledForm = false;
      this.detail= [];
    },
    handleGen(){
      if (this.disabledForm){
        this.enabledForm();
      }else{
        this.$refs.form.validate((valid) => {
          if (!valid) {
            this.displayMessage("form-warning");
            return;
          }
          this.loading.generate = true;
          this.$store
            .dispatch("genPaypembayaranPiutang", { auth: this.getAuth, payload: this.getAuth.username })
            .then((res) => {
              this.detail = res.data;
              //this.displayMessage("success");
              this.loading.generate = false;
              //this.$router.go(-1);
              this.disabledForm = true;
            })
            .catch((err) => {
              this.displayMessageValue("basic-error", err.response.data.message);
              this.loading.generate = false;
            });
        });
      }
    },
    edit(val){
      this.modalEdit = true;
      this.$nextTick(function () {
        this.formedit.setFieldsValue({
          id: val.piutang_karyawan_id,
          val: val.value_installment,
        });
      });
    },
    delet(val){
      this.detail = _.filter(
        this.detail,
          (nav) => nav.piutang_karyawan_id!=val.piutang_karyawan_id
      );
    },
    handleOk(){
      this.formedit.validateFields((err, values) => {
        if (err) {
          this.formedit.resetFields()
          this.displayMessage("form-warning");
          return;
        }

        const index = this.detail.findIndex((el) => el.piutang_karyawan_id === values.id);
        let oldval = Number(this.detail[index].value_installment);
        this.detail[index].value_installment = values.val;
        this.detail[index].remaining_balance =(oldval+Number(this.detail[index].remaining_balance))-Number(values.val);
        
        this.modalEdit = false;
      });
    },
    handleClose(){
      this.formedit.resetFields();
      this.modalEdit = false;
    },
    handleAddDetail(e){
      e.stopPropagation();
      this.tlcAddDetail = this.tlcAdditional;
      this.modalAddTlc = true;
    },
    handleCloseAddDetail(){
      this.modalAddTlc = false;
    },
    handleOKAddDetail(){
      if(this.tlcAddDetail.length==0){
        this.displayMessageValue("error-other", "TLC Can't be null!");
      }else{
        let paramdata = {
          tlc: this.tlcAddDetail,
          id_manifest: this.id
        }
        this.loadConfirmAddDetail = true;
        this.asyncAxiosPut("Pembayaran_piutang/revisi", "application/json", this.getAuth, paramdata)
          .then(() => {
            this.loadConfirmAddDetail = false;
            this.displayMessage("success-save")
            setTimeout(
              function () {
                this.$router.go(0);
              }.bind(this),
              1500
            );
          })
          .catch((err) => {
            let response = Object.assign({}, err.response);
            if (response.data.status == false && response.data.message) {
              this.displayMessageValue("error-other", response.data.message);
            } else {
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error", responses);
            }
          });
      }
    },
    generateOption(){
      let thn = [moment().format('YYYY'), moment().subtract(1, 'year').format('YYYY')]
      for (let index = 0; index < thn.length; index++) {
        for (let index2 = 0; index2 < 12; index2++) {
          this.option.periode.push({
            value: moment().set('year', thn[index]).set('month', 11-index2).format('YYYY-MM'),
            label: moment().set('year', thn[index]).set('month', 11-index2).format('MMMM YYYY')
          })
        }
      }
      
    },
  },
};
</script>

<style lang="less" scoped>
.action {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: @padding -@padding -@padding -@padding;
  padding: @padding;
  background-color: darken(white, 5);
  border-top: 1px solid darken(white, 10);
}
</style>
